<template>
<div class="right-column">
    <!-- 头部区域：right-header容器和返回按钮并列 -->
    <div class="header-row">
      <div class="right-header">
        <!-- 左侧：异常提醒和数量 -->
        <div class="header-left">
          <h2>异常提醒</h2>
          <div class="alarm-total" :title="`异常总数：${alarmData.length}`">{{ alarmData.length }}</div>
        </div>
      </div>
      <!-- 两个小按钮单独包一层：它们之间的间距（.hdr-tools gap）比和卡片之间的间距更小 -->
      <div class="hdr-tools">
        <!-- 全屏 / 退出全屏：整个驾驶舱铺满屏幕（与 StationViewGas 顶栏同款按钮，紧挨在主页按钮左边） -->
        <button
          class="fs-btn"
          type="button"
          :title="fs ? '退出全屏（Esc）' : '全屏显示'"
          :aria-label="fs ? '退出全屏' : '全屏显示'"
          @click="toggleFs"
        >
          <svg v-if="!fs" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <!-- 返回主页：最右侧，仅一个实心蓝色小房子（与 StationViewGas 完全同款） -->
        <button class="back-btn" type="button" title="返回主页" @click="backHome">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M11.34 3.28a1 1 0 0 1 1.32 0l8.4 7.36a1 1 0 0 1-.66 1.75H19.4v7.4a1.4 1.4 0 0 1-1.4 1.4h-3.4v-5.6h-5.2v5.6H6a1.4 1.4 0 0 1-1.4-1.4v-7.4H3.6a1 1 0 0 1-.66-1.75z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
    </div>

    
    <div class="alarm-container">
      <div class="alarm-list" ref="alarmList">
        <div 
          v-for="(alarm, index) in alarmData" 
          :key="index" 
          class="alarm-item"
          :class="{'warning': alarm.type === '延期', 'error': alarm.type === '故障', 'info': alarm.type === '预警'}"
        >
          <!-- 第一行：时间在左侧，type在右上角 -->
          <div class="alarm-row-first">
            <div class="alarm-time" :title="alarm.time">{{ alarm.time }}</div>
            <div class="alarm-type">{{ alarm.type }}</div>
          </div>
          
          <!-- 第二行：内容，使用title属性实现tooltip悬浮显示 -->
          <div 
            class="alarm-content" 
            :title="alarm.content"
          >
            {{ alarm.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserInfoUtils from '@/utils/userInfoUtils.js';
/* 全屏开关：优先原生 Fullscreen API，不支持时自动退回铺满视口（与其他看板共用同一份实现） */
import { toggleFullscreen, onFullscreenChange } from '../../js/fullscreen.js';

// 引入mockDashboard接口
// import { getAbnormalList } from '@/api/mainapi.js';
export default {
  name: 'DashboardRightAlarm',
  data() {
    return {
      alarmData: [], // 初始化空数组
      scrollTimer: null,
      fs: false, // 是否处于全屏（按钮图标 / 提示跟着切）
      
      // // 加载状态
      // loading: false,
      // errorMessage: '',
      
      // 添加滚动控制变量
      isScrolling: false,
      scrollInterval: 50, // 滚动间隔（毫秒）
      scrollSpeed: 1, // 每次滚动的像素数
    };
  },
  props: {
    exceptionList: Array
  },
  watch: {
  exceptionList: {
    immediate: true,
    handler(val) {
      if (!Array.isArray(val)) return

      this.alarmData = val.map(item => ({
        time: item.发生时间 ? item.发生时间.substring(0, 10) : '',
        type: item.异常类型 || '异常',
        content: [
          item.合同编号,
          item.任务号,
          item.相关节点人,
          item.事件详情
        ].filter(Boolean).join(' | ')
      }))

      this.$nextTick(() => {
        this.startAutoScroll()
      })
    }
  }
},
  // mounted() {
  //   this.$nextTick(() => {
  //     // 首先获取异常提醒数据
  //     this.getAlarmData().then(() => {
  //       // 数据加载完成后开始自动滚动
  //       this.startAutoScroll();
  //     }).catch(() => {
  //       // 即使获取数据失败，也尝试启动滚动
  //       this.startAutoScroll();
  //     });
  //   });
  // },
  beforeDestroy() {
    this.stopAutoScroll();
    if (this.offFsChange) this.offFsChange(); // 摘掉全屏状态监听
  },
  mounted() {
    // 原生全屏按 ESC / F11 退出时不经过按钮，靠这个把按钮图标同步回来
    this.offFsChange = onFullscreenChange((on) => { this.fs = on; });
  },
  methods: {
    /* ---------- 全屏 ---------- */
    // 全屏的对象是整个驾驶舱（外层 .home 根元素），不是右侧这一栏
    toggleFs() {
      const el = this.$el.closest('.home') || this.$el;
      toggleFullscreen(el, (on) => { this.fs = on; });
    },

// /**
//  * 获取异常提醒数据
//  * 调用 getAbnormalList 接口
//  */
// async getAlarmData() {
//   this.loading = true;
//   this.errorMessage = '';

//   const params = {
//     taskNo: "",
//     contractNo: "",
//     projectNo: "",
//     operator: "",
//     pageNo: "1",
//     pageSize: "1000",
//     time:"2026-05-20",
//     // time: new Date().toISOString().split('T')[0]
//   };

//   try {
//     const res = await getAbnormalList(params);

//     if (res.data.code === 200) {
//       const rawList = res.data.data["异常信息"] || [];

//       // 字段映射
//       this.alarmData = rawList.map(item => ({
//         time: item["发生时间"]
//           ? item["发生时间"].substring(0, 10)
//           : '',
//         type: item["异常类型"] || '',
//         content: [
//           item["合同编号"],
//           item["任务号"],
//           item["相关节点人"],
//           item["事件详情"]
//         ]
//           .filter(Boolean)
//           .join(' | ')
//       }));

//       console.log('异常提醒数据获取成功，共', this.alarmData.length, '条');
//     } else {
//       console.error('获取异常提醒数据失败:', res.data.message);
//       this.useDefaultAlarmData();
//     }
//   } catch (error) {
//     console.error('获取异常提醒数据异常:', error);
//     this.useDefaultAlarmData();
//   } finally {
//     this.loading = false;
//   }
// },

    // /**
    //  * 使用默认异常数据
    //  * 当接口调用失败时使用默认数据
    //  */
    // useDefaultAlarmData() {
    //   this.alarmData = [
    //     { time: '2025-03-01', type: '延期', content: 'BOM试尝试11111111111111111111111122222222222222222222222222222' },
    //     { time: '2025-02-28', type: '延期', content: '采购订单交付延期' },
    //     { time: '2025-02-28', type: '预警', content: '生产线设备预警' },

    //   ];
    // },
    
    /**
     * 开始自动滚动
     */
    startAutoScroll() {
      // 停止之前可能存在的定时器
      this.stopAutoScroll();
      
      const container = this.$refs.alarmList;
      if (!container || this.alarmData.length === 0) {
        console.log('无法启动自动滚动：容器不存在或数据为空');
        return;
      }
      
      this.isScrolling = true;
      console.log('开始自动滚动异常提醒列表');
      
      this.scrollTimer = setInterval(() => {
        if (!container) {
          this.stopAutoScroll();
          return;
        }
        
        // 元素自增距离顶部1像素
        container.scrollTop += this.scrollSpeed;
        
        // 判断元素是否滚动到底部（加上2像素的容差）
        if (container.scrollTop + container.clientHeight + 2 >= container.scrollHeight) {
          // 重置到顶部重新开始滚动
          container.scrollTop = 0;
          console.log('滚动到底部，重置到顶部重新滚动');
        }
      }, this.scrollInterval);
    },
    
    /**
     * 停止自动滚动
     */
    stopAutoScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
        this.isScrolling = false;
        console.log('停止自动滚动');
      }
    },
    
    /**
     * 格式化日期时间
     * 将时间戳或日期字符串格式化为YYYY-MM-DD格式
     */
    formatDateTime(dateTime) {
      if (!dateTime) return '';
      
      // 如果是时间戳
      if (typeof dateTime === 'number') {
        const date = new Date(dateTime);
        return date.toISOString().split('T')[0];
      }
      
      // 如果是日期字符串
      if (typeof dateTime === 'string') {
        // 尝试解析各种格式
        const date = new Date(dateTime);
        if (!isNaN(date.getTime())) {
          return date.toISOString().split('T')[0];
        }
        // 如果已经是YYYY-MM-DD格式，直接返回
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateTime)) {
          return dateTime;
        }
      }
      
      return String(dateTime);
    },
    
    /**
     * 点击跳转回首页 - 参考homePage.vue
     */
    backHome() {
      // 返回主页：按权限决定（有项目管理权限→项目主页，否则→合同主页），避免跳转到无权限的项目页
      this.$router.push(UserInfoUtils.getDefaultHomeRoute());
    },
    
    /**
     * 手动刷新异常数据
     */
    refreshAlarmData() {
      console.log('手动刷新异常提醒数据');
      
      // 先停止当前的滚动
      this.stopAutoScroll();
      
      this.getAlarmData().then(() => {
        // 数据加载完成后重新开始滚动
        this.startAutoScroll();
      }).catch(() => {
        // 即使获取数据失败，也尝试启动滚动
        this.startAutoScroll();
      });
    },
    
    /**
     * 暂停/恢复自动滚动
     */
    toggleAutoScroll() {
      if (this.isScrolling) {
        this.stopAutoScroll();
      } else {
        this.startAutoScroll();
      }
    }
  }
};
</script>

<style scoped>
/* 右侧栏：占整个页面的20% */
/* 右侧栏：占整个页面的20% */
.right-column {
  flex: 2;  /* 使用flex比例代替固定宽度，实现20% */
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 0; /* 允许内容缩小 */
  overflow: hidden; /* 防止溢出 */
}

/* 头部行：right-header容器 + 右侧两个小按钮（全屏 / 返回首页）并列 */
.header-row {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  gap: 8px; /* 卡片与按钮组之间的距离 */
  margin-bottom: 8px;
  margin-top: 0px;
  width: 100%;
}

/* 右侧按钮组：全屏 + 返回主页，两者之间贴得近一些（gap 比与卡片之间的距离小） */
.hdr-tools {
  display: flex;
  align-items: center;
  gap: 0px; /* 两个按钮之间只留一点点缝 */
  flex: 0 0 auto;
}

/* 头部区域 - 只包含异常提醒和数量（收窄：内边距和标题都调小） */
.right-header {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  background: rgba(5, 149, 235, 0.1);
  border: 1px solid rgba(5, 149, 235, 0.3);
  border-radius: 8px;
  padding: 4px 8px;
  flex: 1; /* 占用可用空间 */
  min-width: 0; /* 允许内容收缩 */
}

.right-header:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(5, 149, 235, 0.3);
  border-color: #74efff;
}

/* 左侧：标题和异常数量 - 占用所有可用空间 */
.header-left {
  display: flex;
  align-items: center;
  gap: 12px; /* 标题和数字之间的间距 */
  flex: 1; /* 占用所有可用空间 */
  min-width: 0; /* 允许内容收缩 */
}

/* 返回主页按钮：无边框无底色，仅一个小房子图标（与 StationViewGas 的 .back-btn 同款） */
.back-btn {
  flex: 0 0 auto;
  width: 30px; height: 30px;
  display: grid; place-items: center;
  padding: 0; border: 0; border-radius: 8px;
  color: #0595EB; background: transparent;
  cursor: pointer; font-family: inherit;
  transition: color .15s, background .15s, transform .15s;
}
.back-btn svg { width: 18px; height: 18px; }
.back-btn:hover { color: #ffffff; background: rgba(5, 149, 235, .32); transform: translateY(-1px); }
.back-btn:active { transform: translateY(0); }

/* 全屏按钮：与「返回主页」同尺寸同观感，放在它左边（与 StationViewGas 的 .fs-btn 同款） */
.fs-btn {
  flex: 0 0 auto;
  width: 30px; height: 30px;
  display: grid; place-items: center;
  padding: 0; border: 0; border-radius: 8px;
  color: #0595EB; background: transparent;
  cursor: pointer; font-family: inherit;
  transition: color .15s, background .15s, transform .15s;
}
.fs-btn svg { width: 18px; height: 18px; }
.fs-btn:hover { color: #ffffff; background: rgba(5, 149, 235, .32); transform: translateY(-1px); }
.fs-btn:active { transform: translateY(0); }

/* 异常数量 - 只显示数字（随头部一起收窄） */
.alarm-total {
  color: #ff6b6b;
  font-size: 15px; /* 数值字号下调，和收窄后的头部协调 */
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 0px;
  background: rgba(255, 107, 107, 0.1);
  border-radius: 4px;
  border: 1px solid rgba(255, 107, 107, 0.3);
  width: 30px; /* 确保数字显示空间 */
  min-width: 20px; /* 确保数字显示空间 */
  height: 30px; /* 与两个按钮同高 */
  min-height: 20px; /* 固定高度 */
  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.2);
  transition: all 0.3s ease;
}

.alarm-total:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(255, 107, 107, 0.3);
  background: rgba(255, 107, 107, 0.15);
}

.right-header h2 {
  color: #cdddf7;
  font-size: 15px;
  font-weight: bold;
  margin: 0;
  background: linear-gradient(45deg, #00aeff, #74efff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  white-space: nowrap; /* 防止标题换行 */
  flex-shrink: 0; /* 禁止标题收缩 */
}

 /* ------------和列表有关的定义---------------------- */
.alarm-container {
  flex: 1;
  background: rgba(5, 149, 235, 0.1);
  border: 1px solid rgba(5, 149, 235, 0.3);
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.alarm-list {
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px; /* 减小间距，使卡片更紧凑 */
  will-change: transform; /* 优化性能 */
}



/* 修改异常项为两行布局 */
.alarm-item {
  background: rgba(5, 149, 235, 0.05);
  border: 1px solid rgba(5, 149, 235, 0.2);
  border-radius: 6px;
  padding: 10px 12px; /* 减小上下内边距，使卡片更短 */
  display: flex;
  flex-direction: column; /* 改为垂直布局 */
  gap: 2px; /* 行间距 */
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  min-height: 55px; /* 减小最小高度，使卡片更短 */
  max-height: 70px; /* 设置最大高度，控制整体高度 */
  cursor: pointer; /* 添加指针表示可悬浮 */
}

.alarm-item:hover {
  transform: translateX(5px);
  background: rgba(5, 149, 235, 0.1);
  border-color: rgba(5, 149, 235, 0.4);
  box-shadow: 0 3px 8px rgba(0, 174, 255, 0.2);
  max-height: 200px; /* 悬浮时允许展开 */
}

/* 通过不同的边框左侧颜色来区分类型 */
.alarm-item.warning {
  border-left: 4px solid #FECA57;
  background: linear-gradient(90deg, rgba(254, 202, 87, 0.05), rgba(5, 149, 235, 0.05));
}

.alarm-item.error {
  border-left: 4px solid #FF6B6B;
  background: linear-gradient(90deg, rgba(255, 107, 107, 0.05), rgba(5, 149, 235, 0.05));
}

.alarm-item.info {
  border-left: 4px solid #1DD1A1;
  background: linear-gradient(90deg, rgba(29, 209, 161, 0.05), rgba(5, 149, 235, 0.05));
}

/* 第一行布局：时间在左，type在右 */
.alarm-row-first {
  display: flex;
  justify-content: space-between; /* 时间在左，type在右 */
  align-items: center;
  width: 100%;
  flex-shrink: 0; /* 防止被压缩 */
}

/* 时间样式 - 第一行左侧 */
.alarm-time {
  color: #cdddf7;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 4px;
  /* 防止换行，超出显示... */
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  max-width: 100%; /* 限制最大宽度 */
  min-width: 0; /* 允许内容收缩 */
  flex: 1; /* 占用可用空间 */
  transition: all 0.3s ease;
  position: relative;
  padding-right: 2px; /* 为省略号留出空间 */
}

/* 移除时间图标 */
.alarm-time::before {
  display: none; /* 移除时间符号 */
}

/* 类型样式 - 第一行右上角 */
.alarm-type {
  font-size: 10px; /* 较小的字体 */
  font-weight: bold;
  padding: 2px 6px; /* 较小的内边距 */
  border-radius: 10px; /* 胶囊形状 */
  text-align: center;
  white-space: nowrap; /* 不换行 */
  letter-spacing: 0.5px;
  text-transform: uppercase; /* 大写字母 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  flex-shrink: 0; /* 防止被压缩 */
  min-width: 40px; /* 最小宽度确保美观 */
  color: #FF5252; /* 红色文字 */
  background: rgba(255, 107, 107, 0.2); /* 浅红色背景 */
  border: 1px solid rgba(255, 107, 107, 0.4);
  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.3);
}

/* 不同类型的不同颜色 */
.warning .alarm-type {
  color: #FF9800; /* 橙色文字 */
  background: rgba(254, 202, 87, 0.2); /* 浅黄色背景 */
  border: 1px solid rgba(254, 202, 87, 0.4);
  box-shadow: 0 2px 4px rgba(254, 202, 87, 0.3);
}

.error .alarm-type {
  color: #FF5252; /* 红色文字 */
  background: rgba(255, 107, 107, 0.2); /* 浅红色背景 */
  border: 1px solid rgba(255, 107, 107, 0.4);
  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.3);
}

.info .alarm-type {
  color: #4CAF50; /* 绿色文字 */
  background: rgba(29, 209, 161, 0.2); /* 浅绿色背景 */
  border: 1px solid rgba(29, 209, 161, 0.4);
  box-shadow: 0 2px 4px rgba(29, 209, 161, 0.3);
}

/* 内容样式 - 第二行 */
.alarm-content {
  color: #fff;
  font-size: 13px;
  line-height: 1.4;
  flex: 1;
  min-height: 0;
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  display: -webkit-box; /* 使用Webkit盒模型 */
  -webkit-line-clamp: 2; /* 限制显示2行 */
  -webkit-box-orient: vertical; /* 垂直排列 */
  word-break: break-word; /* 允许单词内换行 */
  transition: all 0.3s ease;
  position: relative;
  cursor: default; /* 默认光标 */
  max-height: 2.8em; /* 两行的高度限制 */
  
  /* 添加省略号效果 */
  position: relative;
  padding-right: 0;
}



/* 修改悬浮状态，不再展开内容区域 */
.alarm-item:hover {
  transform: translateX(5px);
  background: rgba(5, 149, 235, 0.1);
  border-color: rgba(5, 149, 235, 0.4);
  box-shadow: 0 3px 8px rgba(0, 174, 255, 0.2);
  max-height: 70px; /* 保持原有高度，不展开 */
}


/* 滚动条样式 */
.alarm-list::-webkit-scrollbar {
  width: 5px;
}


.alarm-list::-webkit-scrollbar-thumb {
  background: rgba(0, 174, 255, 0.5);
  border-radius: 3px;
}




</style>

